import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "bfit-upload-avatar" }
const _hoisted_2 = { style: {"display":"none"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_profile_avatar = _resolveDirective("profile-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.uploadReady)
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            type: "file",
            id: "files",
            ref: "files",
            onChange: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFilesChanged && _ctx.handleFilesChanged(...args)), ["prevent"]))
          }, null, 544))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["bfit-avatar", {loading: _ctx.loading}]),
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openFileSelector && _ctx.openFileSelector(...args)), ["prevent"]))
    }, null, 2), [
      [_directive_profile_avatar, _ctx.avatarUrl]
    ])
  ]))
}